import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';

import { PrimaryButtonMedium as Button } from '@xingternal/malt-button';

import api from './../../../utils/api';
import { MIN_PASSWORD_LENGTH } from './../../../utils/constants';

import Store from '../../../store';

import PasswordField from './../../../Components/PasswordField/PasswordField';
import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import StretchButtonGroup from './../../../Components/StretchButtonGroup/StretchButtonGroup';
import IllustrationPlaceholder from './../../../Components/Illustrations/IllustrationPlaceholder';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import PasswordStrength from './PasswordStrength/PasswordStrength';
import messages from './messages';

const PasswordRecoveryReset = ({ history: { replace } }) => {
  const { dispatch } = useContext(Store);
  return (
    <Formik
      initialValues={{ password: '' }}
      validateOnBlur={false}
      validateOnChange={false}
      validate={({ password }) => {
        const errors = {};

        if (password.length < MIN_PASSWORD_LENGTH) {
          errors.password = <FormattedMessage {...messages.errorTooShort} />;
        }

        return errors;
      }}
      onSubmit={({ password }, { setErrors, setSubmitting }) => {
        const payload = {
          password,
        };

        api
          .post('/recovery/password/resets', payload)
          .then(({ success }) => {
            if (success) {
              if (window && window.windowsAppWrapper) {
                window.windowsAppWrapper.close();
                return;
              }

              dispatch({ type: 'RESET_PASSWORD' });
              replace('/');
            }
          })
          .catch(err => {
            if (
              err.jsonResponse &&
              err.jsonResponse.error === 'LOGIN_REQUIRED'
            ) {
              replace({
                pathname: '/recovery',
                search: `?error=${err.jsonResponse.error}`,
              });

              return;
            }

            setErrors({ password: err.jsonResponse.error });
            setSubmitting(false);
          });
      }}
      render={({
        handleSubmit,
        errors,
        isSubmitting,
        handleChange,
        values: { password },
      }) => (
        <>
          <IllustrationPlaceholder />

          <PageviewTracker
            pageName={'wbm/Welcome/login/recovery/password/new'}
          />
          <form onSubmit={handleSubmit} method={'POST'}>
            <CustomH>
              <FormattedMessage {...messages.title} />
            </CustomH>
            <CustomP>
              <FormattedMessage {...messages.subline} />
            </CustomP>
            <PasswordField
              label={<FormattedMessage {...messages.labelNew} />}
              handleChange={handleChange}
              messages={messages}
              error={errors && errors.password}
              autoFocus
            />

            <PasswordStrength password={password} />

            <StretchButtonGroup>
              <Button
                loading={isSubmitting}
                disabled={password.length < MIN_PASSWORD_LENGTH}
                type={'submit'}
              >
                <FormattedMessage {...messages.buttonContinue} />
              </Button>
            </StretchButtonGroup>
          </form>
        </>
      )}
    />
  );
};

export default PasswordRecoveryReset;
